import { ReactComponent as Info } from '../assets/info-outline.svg';
import './index.css';

const FormError = ({ error, textColor='#f29e9d', className='' }) => {

  const errorStyle = {
    '--error-text-color': textColor,
  };

  return (
    <div className={`form-error-message ${className}`} style={errorStyle}>
      <Info /> {error}
    </div>
  );
};

export default FormError;